import { makeStyles, tokens } from "@fluentui/react-components";
import { flexParent, flexParentCenterCrossAxis, styleScrollbar } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
/**
 * Styles for the GroundingResourcesDialog component
 */ export const useGroundingResourcesDialogStyles = makeStyles({
    dialogSurface: {
        width: "600px",
        height: "480px",
        ...flexParent("column")
    },
    title: {
        ...flexParent("row"),
        ...flexParentCenterCrossAxis,
        justifyContent: "space-between",
        fontWeight: tokens.fontWeightSemibold,
        marginBottom: tokens.spacingVerticalM
    },
    titleContent: {
        ...flexParent("row"),
        ...flexParentCenterCrossAxis,
        gap: tokens.spacingHorizontalS
    },
    closeButton: {
        minWidth: "auto",
        width: tokens.spacingHorizontalXL,
        height: tokens.spacingHorizontalXL
    },
    content: {
        ...flexParent("column"),
        gap: tokens.spacingVerticalS,
        flex: "1",
        overflow: "hidden"
    },
    description: {
        fontSize: tokens.fontSizeBase300,
        color: tokens.colorNeutralForeground2,
        lineHeight: tokens.lineHeightBase300,
        marginBottom: tokens.spacingVerticalM
    },
    header: {
        ...flexParent("row"),
        ...flexParentCenterCrossAxis,
        justifyContent: "space-between",
        gap: tokens.spacingHorizontalM
    },
    contentTitle: {
        fontSize: tokens.fontSizeBase300,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
        paddingLeft: tokens.spacingHorizontalMNudge
    },
    resourcesContainer: {
        ...styleScrollbar,
        flex: "1",
        maxHeight: "285px",
        overflow: "auto"
    },
    emptyStatePickerContainer: {
        ...flexParent("row"),
        justifyContent: "center",
        width: "100%"
    },
    titleWithInfo: {
        ...flexParent("row"),
        ...flexParentCenterCrossAxis,
        gap: tokens.spacingHorizontalXS
    },
    infoIconContainer: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    infoIcon: {
        width: tokens.spacingHorizontalL,
        height: tokens.spacingHorizontalL,
        color: tokens.colorBrandForeground1,
        borderRadius: "100%",
        ":hover": {
            color: tokens.colorNeutralForegroundInverted,
            backgroundColor: tokens.colorBrandBackground
        }
    }
});
